import ReactDOM from 'react-dom/client';
import React, { useEffect } from 'react';
import { collection, getDocs, query, where } from "firebase/firestore";
import './index.css';
import App from './App';
import { db } from "./firebase.js";
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { ToastProvider } from './components_root/ToastContext';
import Cookies from 'js-cookie';
function IndexWrapper() {
  const [ready, setReady] = React.useState(false);
  // 
  const aooz_websiteuid = "mvY8OGXRFafga5899I";

  //useEffect(() => {
    // const domain = new URL(window.location.href).hostname;
    // const parts = domain.split('.');
    // const rootDomain =
    //   parts.length > 2
    //     ? parts.slice(parts.length - 2).join('.') // handle subdomains
    //     : domain;


    // const checkIntegration = async () => {
    //   try {
    //     const q = query(
    //       collection(db, "websiteservicesdb"),
    //       where("status", "==", true),
    //       where("domain_registration", "==", domain)
    //     );

    //     const snap = await getDocs(q);
    //     if (snap.empty) {
    //       Cookies.set("website_uid", aooz_websiteuid, {
    //         expires: 365,
    //         path: "/", domain: rootDomain
    //       });
    //     } else {
    //       const doc = snap.docs[0].data();
    //       const url = doc?.suid || "no_url";
    //       Cookies.set("website_uid", `${url}`, {
    //         expires: 365,
    //         path: "/", domain: rootDomain
    //       });
    //     }
    //   } catch (err) {
    //     Cookies.set("website_uid", aooz_websiteuid, {
    //       expires: 365,
    //       path: "/", domain: rootDomain
    //     });
 
    //   }
    //   setReady(true);
    // };
    // checkIntegration();
    // try {
    //   const check_login = async () => {
    //     const guid = Cookies.get("guid");

    //     if (!guid) {
    //       return;
    //     }
    //     const companiesRef = collection(db, "companies");
    //     const companiesSnap = await getDocs(companiesRef);

    //     let found = null;

    //     // 2) Loop through each company and check staff_accounts
    //     for (const companyDoc of companiesSnap.docs) {
    //       const staffRef = collection(
    //         db,
    //         "companies",
    //         companyDoc.id,
    //         "staff_accounts"
    //       );

    //       const q = query(
    //         staffRef,
    //         where("status", "==", true),
    //         where("accountguid", "==", guid)
    //       );

    //       const staffSnap = await getDocs(q);

    //       if (!staffSnap.empty) {
    //         found = staffSnap.docs[0].data();
    //         found.companyuid = companyDoc.id;
    //         break;
    //       }
    //     }
    //     if (!found) {
    //       // Remove cookie when no company found
    //       Cookies.remove("select_company_uid", { path: "/", domain: rootDomain });

    //     } else {
    //       // Set cookie when company is found
    //       Cookies.set("select_company_uid", found.companyuid, {
    //         expires: 365,
    //         path: "/",
    //         domain: rootDomain
    //       });
    //     }
    //   }
    //       check_login();
    // } catch (err) {

    // }
 

  //}, []);
 
  //if (!ready) return null; // Prevent first render before cookie set

  return (
    <BrowserRouter>
      <ToastProvider>
        <App />
      </ToastProvider>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <IndexWrapper />
  </React.StrictMode>
);

reportWebVitals();
